import { createContext } from "react";

export const BatchEventDetailsModalContext = createContext();
